import { render, staticRenderFns } from "./Shopware.vue?vue&type=template&id=52bdf8d8&scoped=true&"
import script from "./Shopware.vue?vue&type=script&lang=js&"
export * from "./Shopware.vue?vue&type=script&lang=js&"
import style1 from "./Shopware.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bdf8d8",
  null
  
)

export default component.exports